export const tokens = {
  dark: {
    surfaceBase: '#0c0c0b',
    surfaceRaised: '#161614',
    surfaceOverlay: '#1e1e1b',
    surfaceHover: '#2a2a27',
    borderSubtle: '#2a2a27',
    borderStrong: '#3d3d39',
    inkPrimary: '#f0ede6',
    inkSecondary: '#b5b1aa',
    inkMuted: '#8a8680',
    accent: '#c9a96e',
    accentText: '#c9a96e',
    accentHover: '#d4b87a',
    signalError: '#c0614d',
    signalSuccess: '#6b9e78',
    signalWarning: '#c9a96e',
  },
  light: {
    surfaceBase: '#f7f5f1',
    surfaceRaised: '#f0ede6',
    surfaceOverlay: '#e8e4dc',
    surfaceHover: '#d4d0c8',
    borderSubtle: '#d4d0c8',
    borderStrong: '#b5b1aa',
    inkPrimary: '#161614',
    inkSecondary: '#54524e',
    inkMuted: '#8a8680',
    accent: '#c9a96e',
    accentText: '#8a6a2d',
    accentHover: '#a57f3a',
    signalError: '#9a4434',
    signalSuccess: '#4e7a5a',
    signalWarning: '#8a6a2d',
  },
};

export const getTokens = (mode) => tokens[mode] || tokens.dark;
